<template>
  <div class="sign-activity-edit relative">
    <menu-item label="活动">
      <div class="activity-select">
        <div class="select-trigger" :class="{ 'is-focus': visible }" @click="toggleDropdown">
          <span v-if="selectedLabel" class="selected-text">{{ selectedLabel }}</span>
          <span v-else class="placeholder">请选择活动</span>
          <div class="trigger-icons">
            <i v-if="model.bizId || model.chainId" class="el-icon-circle-close" @click.stop="clearValue" />
            <i class="el-icon-arrow-down" :class="{ 'is-reverse': visible }" />
          </div>
        </div>
        <div v-show="visible" class="select-dropdown">
          <div class="tabs">
            <div class="tab" :class="{ active: activeTab === 'activity' }" @click="changeTab('activity')">活动列表</div>
            <div class="tab" :class="{ active: activeTab === 'chain' }" @click="changeTab('chain')">活动链列表</div>
          </div>
          <div v-show="activeTab === 'activity'" class="list">
            <div v-if="activityLoading" class="status-text">加载中...</div>
            <div v-else-if="activityList.length === 0" class="status-text">暂无活动</div>
            <div
              v-for="item in activityList"
              :key="item.value"
              class="option"
              :class="{ selected: model.bizId === item.value }"
              @click="onSelect(item, 'activity')"
            >
              <im-icon v-if="model.bizId === item.value" class="option-check" icon="icon-selected" />
              <span>{{ item.label }}</span>
            </div>
          </div>
          <div v-show="activeTab === 'chain'" class="list">
            <div v-if="chainLoading" class="status-text">加载中...</div>
            <div v-else-if="chainList.length === 0" class="status-text">暂无活动链</div>
            <div
              v-for="item in chainList"
              :key="item.value"
              class="option"
              :class="{ selected: model.chainId === item.value }"
              @click="onSelect(item, 'chain')"
            >
              <im-icon v-if="model.chainId === item.value" class="option-check" icon="icon-selected" />
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </menu-item>
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <menu-item label="布局">
      <menu-switch v-model="model.titleVisible" target-key="titleVisible" label="标题" />
      <menu-switch v-model="model.subtitleVisible" target-key="subtitleVisible" label="描述" />
      <menu-switch v-model="model.detailVisible" target-key="detailVisible" label="展示道具详情" />
    </menu-item>
    <menu-item label="卡片布局">
      <im-select v-model="model.layout" class="w-full" :options="layoutOptions" size="small" />
    </menu-item>
    <menu-item v-if="SignActivityLayoutEnum.Col === model.layout && $store.getters.isMobile" label="移动端卡片尺寸">
      <im-select v-model="model.cardSize" class="w-full" size="small" target-key="cardSize" :options="cardSizeOptions" />
    </menu-item>
    <menu-item label="卡片圆角">
      <menu-slider v-model="model.radius" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill class="mt-2" :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>
    <menu-item label="按钮文字颜色">
      <menu-fill :target="model.buttonColor" solid-color target-key="buttonColor" />
    </menu-item>
    <menu-item label="奖品卡片背景">
      <menu-background-image :target="model.signBackground" target-key="signBackground" />
      <menu-fill class="mt-2" :target="model.signBackground" target-key="signBackground" />
    </menu-item>
    <menu-item label="奖品Logo背景">
      <menu-background-image :target="model.logoBackground" target-key="logoBackground" />
      <menu-fill class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>
    <menu-item label="不可签按钮">
      <menu-background-image :target="model.doneBackground" target-key="doneBackground" />
      <menu-fill class="mt-2" :target="model.doneBackground" target-key="doneBackground" />
    </menu-item>
    <menu-item label="补签按钮">
      <menu-background-image :target="model.repairBackground" target-key="repairBackground" />
      <menu-fill class="mt-2" :target="model.repairBackground" target-key="repairBackground" />
    </menu-item>
    <menu-item label="可签到/领取按钮">
      <menu-background-image :target="model.buttonBackground" target-key="buttonBackground" />
      <menu-fill class="mt-2" :target="model.buttonBackground" target-key="buttonBackground" />
    </menu-item>
    <menu-item label="不可签到标识">
      <menu-background-image :target="model.unSignMark" target-key="unSignMark" />
    </menu-item>
    <menu-item label="已签到标识">
      <menu-background-image :target="model.signedMark" target-key="signedMark" />
    </menu-item>
    <menu-item label="签到天数背景">
      <menu-fill :target="model.dayTitleBackground" target-key="dayTitleBackground" />
    </menu-item>
    <menu-item label="签到天数文字">
      <menu-fill :target="model.dayTitleColor" solid-color target-key="dayTitleColor" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import RemoveBtn from "~/components/common/RemoveBtn.vue";
import MenuItem from "~/components/menu/menuItem.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue"
import MenuSwitch from "~/components/menu/menuSwitch.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuSlider from '~/components/menu/menuSlider.vue'
import ImSelect from '~/components/common/ImSelect.vue'
import { SignActivityLayoutEnum, SignActivityColLayoutSizeEnum } from '~/enums/data'

export default {
  name: 'SignActivityWidgetEdit',
  components: { ImSelect, MenuSlider, MenuFill, MenuSwitch, MenuBackgroundImage, MenuItem, RemoveBtn },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      SignActivityLayoutEnum,
      visible: false,
      activeTab: 'activity',
      activityList: [],
      activityLoading: false,
      chainList: [],
      chainLoading: false,
      layoutOptions: [
        { label: '一行展示', value: SignActivityLayoutEnum.Row },
        { label: '全部展示', value: SignActivityLayoutEnum.Col }
      ],
      cardSizeOptions: [
        {
          label: '大尺寸3个',
          value: SignActivityColLayoutSizeEnum.Three
        },
        {
          label: '小尺寸4个',
          value: SignActivityColLayoutSizeEnum.Four
        }
      ]
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId
    }),
    selectedLabel() {
      if (this.model.bizId) {
        const item = this.activityList.find((i) => i.value === this.model.bizId)
        return item ? item.label : ''
      }
      if (this.model.chainId) {
        const item = this.chainList.find((i) => i.value === this.model.chainId)
        return item ? item.label : ''
      }
      return ''
    }
  },
  mounted() {
    this.getActivityList()
    this.getChainList()
    document.addEventListener('click', this.handleClickOutside, true)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside, true)
  },
  methods: {
    toggleDropdown() {
      this.visible = !this.visible
      if (this.visible) {
        this.activeTab = this.model.chainId ? 'chain' : 'activity'
      }
    },
    handleClickOutside(e) {
      if (this.visible && !this.$el.contains(e.target)) {
        this.visible = false
      }
    },
    onSelect(item, source) {
      if (source === 'chain') {
        this.model.chainId = item.value
        this.model.bizId = null
      } else {
        this.model.bizId = item.value
        this.model.chainId = null
      }
      this.visible = false
    },
    clearValue() {
      this.model.bizId = null
      this.model.chainId = null
    },
    changeTab(tab) {
      this.activeTab = tab
    },
    async getActivityList() {
      const nowStem = Math.floor(dayjs().utc().valueOf() / 1000)
      const params = {
        now_time: nowStem,
        activity_type: 4,
        player_id: (this.userInfo && this.userInfo.uid) || '',
        project_id: this.projectId || this.userInfo.project_id || ''
      }
      this.activityLoading = true
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList(params))
      this.activityLoading = false
      if (!err) {
        const data = res?.list || []
        this.activityList = data.map((item) => ({
          label: item.name,
          value: item.biz_id
        }))
      }
    },
    async getChainList() {
      const params = {
        activity_type: 4,
        project_id: this.projectId || this.userInfo.project_id || ''
      }
      this.chainLoading = true
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityChainPairs(params))
      this.chainLoading = false
      if (!err) {
        this.chainList = (res || []).filter((item) => Number(item.activity_type) === 4).map((item) => ({
          label: item.chain_name,
          value: item.chain_id
        }))
      }
    }
  }
}
</script>

<style scoped lang="less">
.activity-select {
  position: relative;
}

.select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: normal;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 36px;
  line-height: 36px;
  padding-left: 12px;
  padding-right: 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
  }

  &.is-focus {
    border-color: var(--primary-color);
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.2);
  }

  .selected-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  .trigger-icons {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    .el-icon-circle-close {
      color: rgba(255, 255, 255, 0.4);
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .el-icon-arrow-down {
      color: rgba(255, 255, 255, 0.4);
      font-size: 14px;
      transition: transform 0.3s;

      &.is-reverse {
        transform: rotate(180deg);
      }
    }
  }
}

.select-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 2000;
  background: rgba(30, 30, 35, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 6px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  min-width: 200px;

  .tabs {
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 6px;
    padding: 0 4px;

    .tab {
      flex: 1;
      text-align: center;
      padding: 8px 0;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      border-bottom: 2px solid transparent;
      margin-bottom: -1px;
      transition: all 0.2s;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }

      &.active {
        color: var(--primary-color);
        border-bottom-color: var(--primary-color);
      }
    }
  }

  .list {
    max-height: 200px;
    overflow-y: auto;
  }

  .status-text {
    padding: 12px;
    text-align: center;
    color: rgba(255, 255, 255, 0.4);
    font-size: 13px;
  }

  .option {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    margin-bottom: 2px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    .option-check {
      margin-right: 8px;
      flex-shrink: 0;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      color: white;
    }

    &.selected {
      background: linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.2), rgba(var(--primary-color-rgb), 0.1));
      color: var(--primary-color);
      font-weight: 600;

      &:hover {
        background: linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.25), rgba(var(--primary-color-rgb), 0.15));
      }

      .option-check {
        color: var(--primary-color);
      }
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
